import { forkJoin, of } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { catchError, map, mergeMap } from 'rxjs/operators';
// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Services
// State
import { AppState } from '../../reducers';
// Actions
import { Router } from '@angular/router';
import { AuthService } from '../../auth/_services/auth.service';
import { FilteredViewService } from '../../services/filtered-view.service';
import {
  ClearContactLoginHistoryErrors,
  ContactLoginHistoryActionToggleLoading,
  ContactLoginHistoryActionTypes,
  ContactsLoginHistoryPageCancelled,
  ContactsLoginHistoryPageLoaded,
  ContactsLoginHistoryPageRequested,
  ContactsLoginHistoryPageToggleLoading,
  ThrowContactLoginHistoryError,
} from '../_actions/contact-login-history.actions';
import { ContactsService } from '../_services';

@Injectable()
export class ContactLoginHistoryEffects {
  showPageLoadingDistpatcher = new ContactsLoginHistoryPageToggleLoading({ isLoading: true });
  showActionLoadingDistpatcher = new ContactLoginHistoryActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new ContactLoginHistoryActionToggleLoading({ isLoading: false });

  @Effect()
  loadContactsPage$ = this.actions$.pipe(
    ofType<ContactsLoginHistoryPageRequested>(
      ContactLoginHistoryActionTypes.ContactsLoginHistoryPageRequested,
    ),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.contactsService.getLoginHistory(payload.id, payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new ContactsLoginHistoryPageCancelled();
            } else {
              this.store.dispatch(new ThrowContactLoginHistoryError({ error: response[0] }));
              return new ContactsLoginHistoryPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            this.store.dispatch(new ClearContactLoginHistoryErrors());
            return new ContactsLoginHistoryPageLoaded({
              contactsLoginHistory: result.history,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );
  constructor(
    private actions$: Actions,
    private contactsService: ContactsService,
    private authService: AuthService,
    private store: Store<AppState>,
    private sessionService: FilteredViewService,
    private router: Router,
  ) {}
}
